import CargoService from "@/services/CargoService"
import {router} from "@/router"

export const actions = {
    cadastrarCargo: ({commit, dispatch}) => {
        commit('setCargo', {})

        dispatch('setModalCadastroCargo', true)
        
    },
    listarCargo: ({commit}) => {
        commit('setOverlay', true)
        CargoService.listar()
        .then(res => {
            commit('setCargos', res.data)
            commit('setOverlay', false)
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
        })
    },
    visualizarCargo: ({commit, dispatch}, data) => {
        commit('setCargo', data)
        dispatch('setModalCadastroCargo', true)
    },
    salvarCargo: ({commit, dispatch}, data) => {
        dispatch('setModalCadastroCargo', false)
        commit('setOverlay', true)
        CargoService.salvar(data)
        .then(res => {
            dispatch('listarCargo')
            commit('setOverlay',false)  
            commit('snackbarSuccess', 'Cargo cadastrado.') 
        })
        .catch(e => {
            console.log(e)
            commit('snackbarError', 'Erro ao cadastrar cargo.') 
        })
    },
    atualizarCargo: ({commit, dispatch}, data) => {
        dispatch('setModalCadastroCargo', false)
        commit('setOverlay', true)
        CargoService.atualizar(data)
        .then(res => {
            dispatch('listarCargo')
            commit('setOverlay',false)  
            commit('snackbarInfo', 'Cargo atualizado.') 
        })
        .catch(e => {
            console.log(e)
            commit('snackbarError', 'Erro ao atualizar cargo.') 
        })
    },
    excluirCargo: ({commit, dispatch}, id) => {
        dispatch('setModalCadastroCargo', false)
        commit('setOverlay', false)
        CargoService.excluir(id)
        .then(res => {
            dispatch('listarCargo')
            commit('setOverlay',false)  
            commit('snackbarError', 'Cargo excluído.') 
        })
        .catch(e => {
            console.log(e)
            commit('snackbarError', 'Erro ao excluir cargo.') 
        })
    },
    setModalCadastroCargo: ({commit}, status) => {
        commit('setModalCadastroCargo', false)
        setTimeout(() => {
            commit('setModalCadastroCargo', status)
        }, 100);
    },
    setModalExcluirCargo: ({commit}, status) => {
        commit('setModalExcluirCargo', false)
        setTimeout(() => {
            commit('setModalExcluirCargo', status)
        }, 100);
    },
    
}

export default {}